import { render, staticRenderFns } from "./MyChallenges.vue?vue&type=template&id=6447cd22&scoped=true"
import script from "./MyChallenges.vue?vue&type=script&lang=ts"
export * from "./MyChallenges.vue?vue&type=script&lang=ts"
import style0 from "./MyChallenges.vue?vue&type=style&index=0&id=6447cd22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6447cd22",
  null
  
)

export default component.exports